/**
 * 转场特效 - tv-mosaic(像素溶解)
 * 2019-6-10
 */
(function (root, factory) {
  if (typeof module === 'object' && typeof module.exports === 'object') {
    module.exports = factory(this);
  } else {
      factory(root);
  }
})(this, function (root) {
  // 类构造函数
  function con(scene, option) {
    this.code = option.code || 'Mosaic';
    this.maskEle = $('<div></div>').attr({id: 'maskEle_' + scene.id});
    this.clipPath = null;
    this.arrC = [];
    this.oldI = 0;
  }

  var methods =  {
    init: function (force) {
      this.duration = 1; // 动效持续时间
      this.startAt = 0.5; // 开始时间（场景结束前n秒）
      this.oldI = 0;

      return this.supr(this.startAt, force).then(function () {
      });
    },
    initDom: function() {
      if(!this.maskEle) return;

      var editor = this.scene.editor;

      // svg裁剪元素容器插入播放层的 maskEle 中
      editor.player.maskEle.append(this.maskEle)
      // SVG.js 生成svg元素
      var svgMask = SVG('maskEle_' + this.scene.id).size(editor.clientWidth, editor.clientHeight)
      // 在svg 中生成clipPath元素
      this.clipPath = svgMask.defs().clip().attr({
        id: 'slide_' + this.scene.id + '_mask'
      })

      for(var i=0; i<25; i++) {
        for(var j=0; j<50; j++) {
          let val = i*50 + j
          this.arrC[val] = val
          this.clipPath.rect().attr({
            x: 2*j + '%',
            y: 4*i + '%',
            width: '2.1%', height: '4.1%',
            fill: 'black',
            storke: 'none'
          })
        }
      }
      function randomsort(a, b) {
        return Math.random()>.5?-1:1;
      }
      this.arrC.sort(randomsort);

      this.maskEle.hide()
    },
    show: function(frame) {
      if(!this.isInit) return;
      this.supr(frame);

      var scene = this.scene,
          editor = scene.editor,
          sEle = scene.element.player; // player层的当前 scene

      // 播放层显示，对应scene显示
      editor.player.ele.show();
      sEle.show();
      
      // 衔接上一个场景页的动画(e.g.前0.5s的动画)
      if (frame <= this.entrance.end) {
        this.showFirst(frame)
      }

      // 本场景页的转场动画(e.g.后0.5s的动画)
      if (this.nexts && frame >= this.exit.start) {
        // 隐藏上一个场景页的裁剪元素
        this.prevs && this.prevs.effect.maskEle && this.prevs.effect.maskEle.hide();
        
        var nexts_ele = this.nexts.element.player; // player层中的下一个场景
        var offFrame = frame - this.exit.start; // 当前帧减去动画开始时的帧(动画的帧)

        var val = this.linear(offFrame, 1, 1249, this.totalFrame)

        for(var i=this.oldI; i < val; i++) {
          this.clipPath.get(this.arrC[i]).show()
        }
        this.oldI = Math.round(val);

        nexts_ele.css({
          clipPath: 'url("#'+'slide_' + this.scene.id + '_mask' +'")'
        }).show();

        this.maskEle.show()
        nexts_ele.show()
      }

      // 动画外的时间
      if (frame > this.entrance.end && frame < this.exit.start) {
        this.showMiddle()
        this.initClipPath();
      }
    },
    showNext: function(frame) {
      var val,
          editor = this.scene.editor,
          next_ele = this.nexts.element.player,
          _currentFrame = this.startAt * this.frameRate + frame;
      
      next_ele.css({
        clipPath: 'url("#'+'slide_' + this.scene.id + '_mask' +'")'
      });
      next_ele.show()
      this.maskEle.show()

      val = this.linear(_currentFrame, 1, 1249, this.totalFrame)
      for(var i=this.oldI; i < val; i++) {
        this.clipPath.get(this.arrC[i]).show()
      }
      this.oldI = Math.round(val);
    },
    // 清空DOM,以及一些没必要对象
    clearMask: function() {
      this.maskEle.remove();
      this.maskEle = $('<div></div>').attr({id: 'maskEle_' + this.scene.id});
      this.control = {};
      this.isInit = false;
    },
    initClipPath: function() {
      if(this.clipPath && this.oldI) {
        this.oldI = 0;
        for(var i=0; i< 1250; i++) {
          this.clipPath.get(i).hide()
        }
      }
    }
  }

  var statics = {
  }
  
  if (root.AnimEditor) {
    root.AnimEditor.extendScenesEffect('Mosaic', con, methods, statics);
    return;
  }

  return function (AnimEditor) {
    AnimEditor.extendScenesEffect('Mosaic', con, methods, statics);
  }
});



//////////////////
// WEBPACK FOOTER
// ./static/animengine/js/scene-effects/se-mosaic.js
// module id = Kj23
// module chunks = 16